export const colors = {
    redDay: "#d23627",
    nameDay: "#878787",
};

export const elementIdentifiers = {
    day: ".day",
    dateNumber: ".dateNr",
    dayName: ".dayName",
    dayLines: ".dayLines",
    weekNumber: ".weekNr",
    monthName: ".monthName",
    monthYear: ".monthYear",
    personalDate: ".personalDate",
    personalDateText: ".dateText",
    dayModules: ".dayModules",
    dayModule: ".dayModule",
    weekModule: ".weekModule",
    timestamps: ".timestamps",
    metaRowOne: ".metaRow1",
    metaRowTwo: ".metaRow2",
    metaRowThree: ".metaRow3",
    iconOne: ".icon1",
    iconTwo: ".icon2",
    iconThree: ".icon3",
    ownerPage: {
        name: ".namePlaceholder",
        email: ".emailPlaceholder",
        phone: ".phonePlaceholder",
        greeting: ".greetingPlaceholder",
        orderId: ".orderIdPlaceholder",
        logoOne: ".logo1",
        logoTwo: ".logo2",
        logoThree: ".logo3",
        ownerImage: "#ownerPageImage",
    },
    dynamicText: ".dynamicText",
};

export const dayLetterElementIdentifiers = [
    "dayLetterMonday",
    "dayLetterTuesday",
    "dayLetterWednesday",
    "dayLetterThursday",
    "dayLetterFriday",
    "dayLetterSaturday",
    "dayLetterSunday",
];

export const getIconIdentifier = (position: number) => {
    switch (position) {
        default:
        case 1:
            return elementIdentifiers.iconOne;
        case 2:
            return elementIdentifiers.iconTwo;
        case 3:
            return elementIdentifiers.iconThree;
    }
};

export const englishCulture = "en-GB";

export const sundayTranslation = {
    german: "sonntag",
    swedish: "söndag",
    english: "sunday",
    danish: "søndag",
};
